import { SlashCommand } from './types';

export const firaqCommands: SlashCommand[] = [
    {
        id: 'firaq-entry',
        trigger: '/firaq',
        name: 'LEGAL-FIRAQ Entry',
        description: 'Draft or retrieve an entry/case from LEGAL-FIRAQ.',
        category: 'PRODUCTIVITY',
        icon: 'fas fa-gavel',
        mode: 'prompt',
        integration: 'LEGAL-FIRAQ'
    }
];
